module.exports = __webpack_public_path__ + "img/template.cbd8b5a8.svg";